import { useEffect } from 'react';
import { useNavigation } from '../context/navigation-context-provider';
import { NavigationSyncHelperProps } from '../types/navigation.types';

// This component is used to sync the navigation context with passed in props.
export const PropSyncHelper = ({ auth, config }: NavigationSyncHelperProps) => {
  const { setAuth, setConfig } = useNavigation();

  useEffect(() => {
    const authData = auth || {};
    const configData = config || {};

    authData.displayName = auth?.displayName?.replace(/undefined/g, '')?.trim();

    if (authData.displayName === '') {
      authData.displayName = undefined;
    }

    setAuth((a) => ({
      postLoginRedirectUrl: process.env.NEXT_PUBLIC_POST_LOGIN_REDIRECT_URL,
      ...a,
      ...authData,
    }));

    setConfig((c) => ({
      ...c,
      ...configData,
    }));
  }, [auth, setAuth]);

  return null;
};
